import type { EnrollmentCreateResponseOneOf } from './enrollmentCreateResponseOneOf';
import type { EnrollmentCreateResponseOneOfThree } from './enrollmentCreateResponseOneOfThree';
import type { EnrollmentCreateResponseOneOfFive } from './enrollmentCreateResponseOneOfFive';

export type EnrollmentCreateResponse = EnrollmentCreateResponseOneOf | EnrollmentCreateResponseOneOfThree | EnrollmentCreateResponseOneOfFive;
